import { UniversalRollPage } from "./UniversalRollPage";

const UniversalRoll = () => {
	return <UniversalRollPage />;
};
export default UniversalRoll;
